import { graphql } from '@eluve/graphql.tada';

export const searchBillingCodesQuery = graphql(`
  query searchBillingCodes(
    $query: String!
    $limit: Int!
    $types: [MedicalCodeTypesEnum!]!
  ) {
    searchMedicalCodes(
      args: { search_term: $query, _limit: $limit }
      where: { codeType: { _in: $types } }
    ) {
      __typename
      id
      code
      codeType
      description
    }
  }
`);
